import type { HalebopRequestErrorData } from '~/repository/factory';

/**
 * Fetch telia pay script and token (getTeliaPayToken)
 * Sets store.teliaPayReady when telia pay script function is loaded on window
 *
 * Only use in onMounted lifecycle hook
 */
export const useTeliaPayFetchScript = () => {
  const { $api } = useNuxtApp();
  const checkoutStore = useMyCheckoutStore();
  const notificationStore = useNotificationStore();
  const CHECK_FOR_TP_WINDOW_FUNCTION__INTERVAL_MILLISEC = 50;

  const fetchAndInitTeliaPay = async () => {
    try {
      const response = await $api.teliaPay.getTeliaPayToken();
      checkoutStore.fetchedData._teliaPayToken = response.Token;

      useHead({
        script: [
          {
            src: response.ScriptUrl ?? '',
            tagPosition: 'bodyClose',
            crossorigin: 'anonymous',
          },
        ],
      });
    } catch (e) {
      if (isNuxtError<HalebopRequestErrorData>(e)) {
        notificationStore.setErrorNotificationFromCatchClause(
          'Kunde inte visa Telia Finance',
        );
      }
    }

    const hasSetTeliaPayInitFunction: Ref<boolean> = ref(false);
    const checkIfTPInitFunctionExistsTimer = setInterval(() => {
      if ((window as any).initWebcheckout !== undefined) {
        hasSetTeliaPayInitFunction.value = true;
      }
    }, CHECK_FOR_TP_WINDOW_FUNCTION__INTERVAL_MILLISEC);

    watch(hasSetTeliaPayInitFunction, (value: boolean) => {
      if (value) {
        clearInterval(checkIfTPInitFunctionExistsTimer);
        checkoutStore.ui.teliaPayReady = true;
      }
    });
  };

  const refetchTeliaPayToken = async () => {
    try {
      const response = await $api.teliaPay.getTeliaPayToken();
      checkoutStore.fetchedData._teliaPayToken = response.Token;
    } catch (e) {
      if (isNuxtError<HalebopRequestErrorData>(e)) {
        notificationStore.setErrorNotificationFromCatchClause(
          'Kunde inte visa Telia Finance',
        );
      }
    }
  };

  return {
    fetchAndInitTeliaPay,
    refetchTeliaPayToken,
  };
};
